export function Dropout({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg {...props} viewBox="0 0 399 36" fill="none">
      <path d="M0 0H399L393.882 18.4235C390.997 28.8111 381.539 36 370.758 36H28.2421C17.4611 36 8.00309 28.8111 5.11763 18.4235L0 0Z" />
    </svg>
  );
}
